<script>
export default {
    data() {
        return {
            errorText: '',
        };
    },
    computed: {
        userEditData() {
            return this.$store.getters.USER_EDIT_DATA;
        },
        userDetails() {
            return this.$store.getters.USER_DETAILS;
        },
    },
    methods: {
        async updateName(event) {
            this.$store.commit('USER_EDIT_UPDATE', {
                name: event.target.value,
            });
            this.errorText = await this.$store.dispatch('CHECK_USER_EDIT');
        },
        async updateCompany(event) {
            this.$store.commit('USER_EDIT_UPDATE', {
                company: event.target.value,
            });
            this.errorText = await this.$store.dispatch('CHECK_USER_EDIT');
        },
    },
};
</script>

<template>
    <div class="left_sub_panel_data">
        <!-- User Data Section -->
        <label class="mb_5">Name:</label>
        <input
            type="text"
            class="right_input mb_10"
            v-model="userEditData['name']"
            @change="updateName"
        />
        <label class="mb_5">Company:</label>
        <input
            type="text"
            v-model="userEditData['company']"
            @change="updateCompany"
            class="right_input mb_10"
        />

        <label v-if="errorText !== ''" class="error_text mt_10">{{
            errorText
        }}</label>
    </div>
</template>
